import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SnackBarComponent } from './snack-bar.component';

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [
    SnackBarComponent
  ],
  providers: [
  ],
  declarations: [
    SnackBarComponent
  ]
})
export class SnackBarModule { }